import React from "react";

const NavItem = ({ isActive, mobile, label = 'label', count = 0, ...props }) => {
  return (
    <div
      className={`cursor-pointer border-primary opacity-50 ${
        mobile ? `p-3 text-center` : `pb-4 mr-12`
      } ${isActive ? "border-b-4 opacity-100" : ""}`}
      {...props}
    >
      <div className="flex items-center text-sm lg:text-base uppercase">
        <p className="mr-1 font-bold font-accent">{label}</p>
        {
          count &&
          <p className="font-accent font-normal">({count})</p>
        }
      </div>
    </div>
  );
};

export default NavItem;
